"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _animations = require("@staccx/animations");

var _Caret = _interopRequireDefault(require("../../Icons/Caret"));

var _themeContants = require("../../../constants/themeContants");

var _theming = require("../../../theming");

var _ThemeComponent = _interopRequireDefault(require("../../Theme/ThemeComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ExpandButton = function ExpandButton(_ref) {
  var title = _ref.title,
      isExpanded = _ref.isExpanded,
      props = _objectWithoutProperties(_ref, ["title", "isExpanded"]);

  return _react["default"].createElement(ExpandBtn, _extends({
    isExpanded: isExpanded
  }, props), title, " ", _react["default"].createElement(ExpandIcon, {
    isExpanded: isExpanded
  }));
};

var tProps = {
  listItemButtonComponent: {
    name: "COMPONENT_EXPAND_LIST_ITEM_BTN",
    description: "",
    type: _themeContants.themePropTypes.component
  },
  listItem: {
    name: "EXPAND_LIST_ITEM",
    description: "",
    type: _themeContants.themePropTypes.style
  },
  listIcon: {
    name: "EXPAND_LIST_ICON",
    description: "",
    type: _themeContants.themePropTypes.style
  },
  listButton: {
    name: "EXPAND_LIST_BUTTON",
    description: "",
    type: _themeContants.themePropTypes.style
  },
  expandedItem: {
    name: "EXPAND_LIST_EXPANDED_ITEM",
    description: "",
    type: _themeContants.themePropTypes.style
  },
  expandListIconComponent: {
    name: "COMPONENT_EXPAND_LIST_ICON",
    description: "",
    type: _themeContants.themePropTypes.component
  }
};

var BtnComponent = function BtnComponent(_ref2) {
  var props = _extends({}, _ref2);

  return _react["default"].createElement(_ThemeComponent["default"], _extends({
    tagName: tProps.listItemButtonComponent,
    fallback: ExpandButton
  }, props));
};

var ExpandListItem =
/*#__PURE__*/
function (_Component) {
  _inherits(ExpandListItem, _Component);

  function ExpandListItem(props) {
    var _this;

    _classCallCheck(this, ExpandListItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExpandListItem).call(this, props));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.state = {
      isExpanded: _this.props.expanded
    };
    return _this;
  }

  _createClass(ExpandListItem, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.expanded !== undefined) {
        this.setState({
          isExpanded: nextProps.expanded
        });
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      this.setState({
        isExpanded: !this.state.isExpanded
      });

      if (this.props.onClick) {
        this.props.onClick(event);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          children = _this$props.children,
          className = _this$props.className,
          flush = _this$props.flush,
          onClick = _this$props.onClick,
          variant = _this$props.variant,
          otherProps = _objectWithoutProperties(_this$props, ["title", "children", "className", "flush", "onClick", "variant"]);

      var isExpanded = this.state.isExpanded;
      return _react["default"].createElement(ExpandItem, _extends({
        className: className,
        variant: variant,
        isExpanded: isExpanded
      }, otherProps), _react["default"].createElement(BtnComponent, _extends({}, otherProps, {
        title: title,
        isExpanded: isExpanded,
        onClick: this.handleChange,
        "aria-expanded": isExpanded,
        "aria-controls": title,
        id: title + "2",
        variant: variant
      })), isExpanded && _react["default"].createElement(ExpandedItem, {
        flush: flush,
        id: title,
        "aria-labelledby": title + "2",
        variant: variant,
        isExpanded: isExpanded
      }, children));
    }
  }]);

  return ExpandListItem;
}(_react.Component);

var ExpandItem = _styledComponents["default"].li.withConfig({
  displayName: "ExpandListItem__ExpandItem",
  componentId: "sc-1fnwemd-0"
})(["border-bottom:1px solid ", ";position:relative;&:last-child{border-bottom-width:0;}", ";"], _theming.color.line, (0, _theming.applyVariants)(tProps.listItem));

var IconComponent = function IconComponent(_ref3) {
  var props = _extends({}, _ref3);

  return _react["default"].createElement(_ThemeComponent["default"], _extends({
    tagName: tProps.expandListIconComponent,
    fallback: _Caret["default"]
  }, props));
};

var ExpandIcon = (0, _styledComponents["default"])(IconComponent).withConfig({
  displayName: "ExpandListItem__ExpandIcon",
  componentId: "sc-1fnwemd-1"
})(["position:absolute;right:", ";fill:", ";transition:transform 0.3s ease-out;transform:", ";", ";"], _theming.spacing.small, _theming.color.wcag, function (p) {
  return p.isExpanded ? "rotate(180deg)" : "rotate(0)";
}, (0, _theming.applyVariants)(tProps.listIcon));

var ExpandBtn = _styledComponents["default"].button.withConfig({
  displayName: "ExpandListItem__ExpandBtn",
  componentId: "sc-1fnwemd-2"
})(["background:transparent;border-width:0;color:", ";font-size:", ";font-weight:", ";cursor:pointer;padding:", " ", " ", " ", ";width:100%;text-align:left;display:flex;justify-content:space-between;align-items:center;&:hover,&:focus{color:", ";outline:none;", "{fill:", ";}}", ";"], _theming.color.text, _theming.font.base, function (p) {
  return p.isExpanded ? "bold" : "normal";
}, _theming.spacing.small, _theming.spacing.large, _theming.spacing.small, _theming.spacing.medium, _theming.color.black, ExpandIcon, _theming.color.primary, (0, _theming.applyVariants)(tProps.listButton));

var ExpandedItem = _styledComponents["default"].div.withConfig({
  displayName: "ExpandListItem__ExpandedItem",
  componentId: "sc-1fnwemd-3"
})(["opacity:0;animation:0.4s ", " 0.05s ease-out forwards 1;padding:", " ", " ", ";max-width:", ";margin:auto;line-height:1.8;", ";"], _animations.BounceIn, function (p) {
  return p.flush ? 0 : _theming.spacing.small;
}, function (p) {
  return p.flush ? 0 : _theming.spacing.medium;
}, function (p) {
  return p.flush ? 0 : _theming.spacing.medium;
}, function (p) {
  return p.flush ? "auto" : "540px";
}, (0, _theming.applyVariants)(tProps.expandedItem));

ExpandListItem.defaultProps = {
  expanded: false,
  className: "",
  flush: false
};
ExpandListItem.propTypes = {
  children: _themeContants.commonPropTypes.children.isRequired,
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element, _propTypes["default"].array]).isRequired,
  className: _propTypes["default"].string,
  expanded: _propTypes["default"].bool,
  flush: _propTypes["default"].bool
};
ExpandListItem.themeProps = tProps;
var _default = ExpandListItem;
exports["default"] = _default;